(() => {
  if (window.__one8IntlTelInputInitLoaded) return;
  window.__one8IntlTelInputInitLoaded = true;

  const CSS_URL =
    "https://cdn.jsdelivr.net/npm/intl-tel-input@23/build/css/intlTelInput.min.css";
  const SCRIPT_URL =
    "https://cdn.jsdelivr.net/npm/intl-tel-input@23/build/js/intlTelInput.min.js";
  const UTILS_URL =
    "https://cdn.jsdelivr.net/npm/intl-tel-input@23/build/js/utils.js";
  const PHONE_INPUT_SELECTOR = "input[data-intl-tel-input]";
  const LOADER_STYLE_ID = "one8-intl-tel-input-css";
  const ALLOWED_PHONE_CHARACTERS = /[0-9+()\-\s]/g;
  const INVALID_PHONE_CHARACTERS = /[^0-9+()\-\s]/;

  const ensureStylesheet = () => {
    if (document.getElementById(LOADER_STYLE_ID)) return;

    const link = document.createElement("link");
    link.id = LOADER_STYLE_ID;
    link.rel = "stylesheet";
    link.href = CSS_URL;
    document.head.appendChild(link);
  };

  const loadLibrary = () => {
    if (window.intlTelInput) return Promise.resolve(window.intlTelInput);
    if (window.__one8IntlTelInputScriptPromise)
      return window.__one8IntlTelInputScriptPromise;

    window.__one8IntlTelInputScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve(window.intlTelInput);
      script.onerror = () =>
        reject(new Error("Failed to load intl-tel-input library"));
      document.head.appendChild(script);
    });

    return window.__one8IntlTelInputScriptPromise;
  };

  const sanitizePhoneValue = (value) =>
    (value.match(ALLOWED_PHONE_CHARACTERS) || []).join("");

  const addPhoneCharacterFilter = (phoneInput) => {
    if (phoneInput.dataset.phoneCharacterFilterReady === "true") return;

    phoneInput.addEventListener("beforeinput", (event) => {
      if (!event.data || event.inputType?.startsWith("delete")) return;
      if (INVALID_PHONE_CHARACTERS.test(event.data)) event.preventDefault();
    });

    phoneInput.addEventListener("input", () => {
      const sanitizedValue = sanitizePhoneValue(phoneInput.value);
      if (phoneInput.value === sanitizedValue) return;

      const selectionStart = phoneInput.selectionStart ?? sanitizedValue.length;
      const removedBeforeCursor =
        phoneInput.value.slice(0, selectionStart).length -
        sanitizePhoneValue(phoneInput.value.slice(0, selectionStart)).length;

      phoneInput.value = sanitizedValue;
      phoneInput.setSelectionRange(
        selectionStart - removedBeforeCursor,
        selectionStart - removedBeforeCursor,
      );
    });

    phoneInput.dataset.phoneCharacterFilterReady = "true";
  };

  const initializeInput = (phoneInput) => {
    if (!(phoneInput instanceof HTMLInputElement)) return;
    if (phoneInput.dataset.intlTelReady === "true") return;

    addPhoneCharacterFilter(phoneInput);

    const form = phoneInput.closest("form");
    if (!form) return;

    const hiddenInputId = phoneInput.dataset.intlTelHiddenId;
    const hiddenInput = hiddenInputId
      ? document.getElementById(hiddenInputId)
      : form.querySelector("input[data-intl-tel-hidden]");

    if (!(hiddenInput instanceof HTMLInputElement)) return;

    const iti = window.intlTelInput(phoneInput, {
      initialCountry: phoneInput.dataset.intlTelInitialCountry || "in",
      separateDialCode: true,
      loadUtils: UTILS_URL,
    });

    const syncHiddenPhoneValue = () => {
      hiddenInput.value = iti.getNumber() || phoneInput.value.trim();
    };

    phoneInput.addEventListener("input", syncHiddenPhoneValue);
    phoneInput.addEventListener("countrychange", syncHiddenPhoneValue);
    form.addEventListener("submit", syncHiddenPhoneValue);
    syncHiddenPhoneValue();

    phoneInput.dataset.intlTelReady = "true";
  };

  const initializeAll = () => {
    ensureStylesheet();

    loadLibrary()
      .then(() => {
        document
          .querySelectorAll(PHONE_INPUT_SELECTOR)
          .forEach((phoneInput) => {
            initializeInput(phoneInput);
          });
      })
      .catch(() => {
        // Fail silently to avoid blocking form submission if CDN is unavailable.
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", initializeAll);
})();
